import Vue from 'vue'
import VueScrollTo from "vue-scrollto";
import VueRx from 'vue-rx'
import VuejsClipper from "vuejs-clipper/dist/vuejs-clipper.umd";
import 'vuejs-clipper/dist/vuejs-clipper.css';
import './public-path';
import CnxJsonBinder from "@/components/common/CnxJsonBinder.vue";
import VModal from "vue-js-modal";

// axios.defaults.baseURL = window.__settings.url;

Vue.use(VModal);
Vue.use(VueScrollTo, {
	container: "body",
	duration: 400,
	easing: "ease",
	offset: -120, // header-height
	force: true,
	cancelable: true
});
Vue.use(VueRx);
Vue.use(VuejsClipper, {
	components: {
		clipperBasic: true,
		clipperFixed: true
	}
});

Vue.component('cnx-json-binder', CnxJsonBinder);

Vue.component(
	'cnx-digipass',
	() => import(/* webpackChunkName: "cnx-digipass" */'@/components/digipass/CnxDigipass')
);
Vue.component(
	'cnx-organizer-create-course',
	() => import(/* webpackChunkName: "cnx-organizer-create-course" */'@/components/organizer-create-course/OrganizerCreateCourse')
);

document.addEventListener("DOMContentLoaded", () => {
	for (const element of document.querySelectorAll<HTMLElement>('.vue-app')) {
		let scriptElement = element;

		if (element.tagName.toLowerCase() !== 'script') {
			const elFound = element.querySelector<HTMLElement>('script');

			if (elFound) {
				scriptElement = elFound;
			} else {
				console.error('Could not found script tag inside .vue-app element');
				break;
			}
		}

		new Vue({
			render: h => h(CnxJsonBinder, {
				props: {
					component: scriptElement.dataset.component,
					json: scriptElement.innerHTML,
				}
			})
		}).$mount(element)
	}
});

